module.exports = __webpack_public_path__ + "img/BTS-Lacnor.539285dd.png";